import { render, staticRenderFns } from "./TopSales.vue?vue&type=template&id=5a30977a&scoped=true&"
import script from "./TopSales.vue?vue&type=script&lang=js&"
export * from "./TopSales.vue?vue&type=script&lang=js&"
import style0 from "./TopSales.vue?vue&type=style&index=0&id=5a30977a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30977a",
  null
  
)

export default component.exports